import React, { FC, JSX, useEffect, useState } from 'react';
import './ModalChatView.scss';
import ModalDefault from '../../../ModalDefault/ModalDefault';
import { ChatModel } from '../../../../models/Chat/ChatModel';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import DropdownMenuTable from '../../../DropdownMenuTable/DropdownMenuTable';
import moment from 'moment';
import { ChatMessageModel } from '../../../../models/Chat/ChatMessageModel';
import AppPagination from '../../../AppPagination/AppPagination';
import { useChatsHistory } from '../../../../providers/Chats/ChatsHistoryProvider';
import { ChatsSenderEnum } from '../../../../enums/Chat/ChatSenderEnum';
import ChatMessageList from '../../ChatMessageList/ChatMessageList';
import { usePaginate } from '../../../../providers/PaginateProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

interface ModalChatViewProps {
  show: boolean;
  onClose: () => void;
}

const ModalChatView: FC<ModalChatViewProps> = ({ show, onClose }) => {
  const [modeView, setModeView] = useState<'list' | 'chat'>('list');

  const { chat, chatsMessages, pagesMessages, paramsMessages, setParamsMessages, setShowModalMessageView, setSelectedMessage } = useChatsHistory();
  const { handlePaginate } = usePaginate();

  const handleClose = () => {
    onClose();
  }

  const renderList = (): JSX.Element => {
    return (
      <div className="table-responsive">
        <table className="table table-flush m-0 w-100">
          <thead className="thead-light">
            <tr>
              <th className="text-uppercase opacity-7 text-center" scope="col">#</th>
              <th className="text-uppercase opacity-7 text-center" scope="col">Responsável</th>
              <th className="text-uppercase opacity-7" scope="col">Mensagem</th>
              <th className="text-uppercase opacity-7 text-center" scope="col">Data Mensagem</th>
              <th className="text-uppercase opacity-7 text-center" scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            {chatsMessages && chatsMessages?.length > 0 ? (
              <>
                {chatsMessages.map((x: ChatMessageModel, key: number) => (
                  <tr key={x.id} className="text-sm">
                    <td className="text-center">{x.id}</td>
                    <td className="text-center">{x?.sender === ChatsSenderEnum.USER ? 'Usuário' : 'IA'}</td>
                    <td className="text-wrap">{x?.content}</td>
                    <td className="text-center">{moment(x?.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                    <td className="text-center">
                      {x?.sender === ChatsSenderEnum.AGENT && (
                        <DropdownMenuTable key={key}>
                          <Dropdown.Item className="border-radius-md py-2" onClick={() => { setShowModalMessageView(true); setSelectedMessage(x) }}>
                            <FontAwesomeIcon icon={faEye} className="me-2" /> Visualizar Mensagem
                          </Dropdown.Item>
                        </DropdownMenuTable>
                      )}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={5} className="text-center text-sm">Não há registros</td>
              </tr>
            )}
          </tbody>
        </table>

        {chatsMessages && chatsMessages?.length > 0 && (
          <div>
            <nav aria-label="...">
              <AppPagination
                pages={pagesMessages}
                handlePaginate={handlePaginate}
                params={paramsMessages}
                setParams={setParamsMessages}
                style={{ backgroundColor: '#fff' }}
              />
            </nav>
          </div>
        )}
      </div>
    );
  }

  const renderChat = (): JSX.Element => {
    return (
      <div
        className="chats-wrapper"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/img/background-wrapper.png)`,
          backgroundPosition: 'top center',
          backgroundRepeat: 'repeat',
        }}
      >
        <div className="chat-messages-container">
          <Container>
            <Row className="justify-content-center">
              <Col md={12}>
                <ChatMessageList messages={chatsMessages} />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }

  useEffect(() => {
    show && setModeView('list');
  }, [show]);

  useEffect(() => {
    if (show) {
      if (modeView === 'list') {
        setParamsMessages({ ...paramsMessages, page: 1, perPage: 10, withPaginate: true });
      } else if (modeView === 'chat') {
        setParamsMessages({ ...paramsMessages, withPaginate: false });
      }
    }
  }, [show, modeView]);

  return (
    <ModalDefault
      title={`Visualizar Chat`}
      show={show}
      onClose={handleClose}
      sizeModal={"xxl"}
      showFooter={true}
      backdrop="static"
      backgroundColor="#fff"
    >
      <div className="ModalChatView" data-testid="ModalChatView">
        <Row>
          <Col>
            <div className="d-flex gap-2 align-items-center justify-content-between">
              <div className="chat-header-info">
                <h5 className="mb-0">Chat #{chat?.id || ''}</h5>
                {chat?.user?.name && (
                  <p className="text-sm mb-0 user-info">
                    {chat?.user?.partner_code && (
                      <strong><span className="partner-code">{chat.user.partner_code}</span></strong>
                    )}
                    <strong className="user-name">{chat.user.name}</strong>
                  </p>
                )}
              </div>
              <div id="btn-view" className="d-flex gap-2">
                <button type="button" className={`btn btn-default bg-white ${modeView === 'list' ? 'active' : ''}`} onClick={() => setModeView('list')}>
                  <i className="fas fa-list"></i>
                </button>
                <button type="button" className={`btn btn-default bg-white ${modeView === 'chat' ? 'active' : ''}`} onClick={() => setModeView('chat')}>
                  <i className="fas fa-comments"></i>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            {modeView === 'list' ? renderList() : renderChat()}
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
}

export default ModalChatView;
